exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-e682ddfc] .md-tab {\n  width: 100%;\n  min-width: 100%;\n  padding: 0;\n}\n.tabs[data-v-e682ddfc] .md-tabs-navigation {\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.tabs[data-v-e682ddfc] .md-tabs-navigation .md-button {\n  min-width: 50px !important;\n}\n.tabs[data-v-e682ddfc] .md-tabs-navigation .md-button .md-ripple {\n    padding: 0 12px;\n}\n.tabs[data-v-e682ddfc] .md-tabs-navigation .md-button .md-ripple i {\n      color: #578AD6;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e682ddfc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/sales/sale_details/Sales.Tabs.vue
// module id = oAJl
// module chunks = 1